/** Altura padronizada: faixa do logo no menu = supertopo. */
export const HEADER_BAND_HEIGHT_PX = 72

export const SIDEBAR_WIDTH_EXPANDED = 272
export const SIDEBAR_WIDTH_COLLAPSED = 52
